var map = {
	"./angular.png": "2feb",
	"./css.png": "e4d5",
	"./html.png": "b55a",
	"./js.png": "f505",
	"./laravel.png": "138f",
	"./logo.png": "cf05",
	"./mysql.png": "808d",
	"./php.svg": "1540",
	"./postgres.png": "37eb",
	"./profile.jpg": "3a19",
	"./projectImage/cinema.png": "00e3",
	"./projectImage/frontendmentor.png": "e4c0",
	"./projectImage/pokemon.png": "58a8",
	"./projectImage/speed.png": "62ab",
	"./sass.png": "7266",
	"./spring.png": "9366",
	"./ts.png": "abe2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";